import type { Customers } from "gql/api";
import type { InjectionKey, Ref } from "vue";

export type BuildInfo = {
  BUILD_ID: string;
  BUILD_TIME: string;
  GIT_COMMIT: string;
  GIT_BRANCH: string;
};

export const buildInfoKey: InjectionKey<BuildInfo> = Symbol("buildInfo");

export const primaryCustomerKey: InjectionKey<Ref<Customers | undefined>> =
  Symbol("primaryCustomer");
